import { nostoSessionParams } from '@stores/nostoSessionStore'

// Helper function to get session params from the store
export const getSessionParamsFromStore = () => {
    try {
        const params = nostoSessionParams.get()
        return params || null
    } catch (error) {
        console.error('Error getting session params from store:', error)
        return null
    }
}

// Helper function to get session params with fallback
export const getNostoSessionParamsWithFallback = async () => {
    try {
        // First try to get from store
        const storedParams = getSessionParamsFromStore()

        if (storedParams) {
            return storedParams
        }

        // If not in store, try to get from Nosto API
        if (typeof window !== 'undefined' && window.nostojs) {
            return new Promise((resolve) => {
                // Add a timeout to prevent hanging
                const timeout = setTimeout(() => {
                    console.log('🔍 getNostoSessionParamsWithFallback - Timeout reached, returning null');
                    resolve(null);
                }, 3000); // 3 second timeout

                try {
                    window.nostojs((api) => {
                        // Check if the API has the required method
                        if (typeof api.getSearchSessionParams === 'function') {
                            api.getSearchSessionParams()
                                .then(response => {
                                    clearTimeout(timeout);
                                    console.log('🔍 getNostoSessionParamsWithFallback - Session params retrieved:', response);
                                    resolve(response);
                                })
                                .catch(error => {
                                    clearTimeout(timeout);
                                    console.error('🔍 getNostoSessionParamsWithFallback - Error getting session params:', error);
                                    resolve(null);
                                });
                        } else if (typeof api.getSessionParams === 'function') {
                            // Try alternative method name
                            api.getSessionParams()
                                .then(response => {
                                    clearTimeout(timeout);
                                    console.log('🔍 getNostoSessionParamsWithFallback - Session params retrieved (alt method):', response);
                                    resolve(response);
                                })
                                .catch(error => {
                                    clearTimeout(timeout);
                                    console.error('🔍 getNostoSessionParamsWithFallback - Error getting session params (alt method):', error);
                                    resolve(null);
                                });
                        } else {
                            // If no session params method is available, try to get from default session
                            clearTimeout(timeout);
                            console.log('🔍 getNostoSessionParamsWithFallback - No session params method available, trying default session');
                            try {
                                api.defaultSession()
                                    .then(session => {
                                        if (session && session.params) {
                                            resolve(session.params);
                                        } else {
                                            resolve(null);
                                        }
                                    })
                                    .catch(error => {
                                        console.error('🔍 getNostoSessionParamsWithFallback - Error getting default session:', error);
                                        resolve(null);
                                    });
                            } catch (error) {
                                console.error('🔍 getNostoSessionParamsWithFallback - Error accessing default session:', error);
                                resolve(null);
                            }
                        }
                    });
                } catch (error) {
                    clearTimeout(timeout);
                    console.error('🔍 getNostoSessionParamsWithFallback - Error calling nostojs:', error);
                    resolve(null);
                }
            });
        }

        return null;
    } catch (error) {
        console.error('🔍 getNostoSessionParamsWithFallback - Error in getNostoSessionParamsWithFallback:', error);
        return null;
    }
}
